export default "__VITE_ASSET__DKd9O9Z4__"